import React from "react";

function MelorianBijoux() {
  return (
    <div class="row">
      <div class="col-md-12 margin_60 description">
        <h2 class="margin_30">
          Développement web e-commerce - MelorianBijoux . nuxtjs 4
        </h2>
        <div class="row">
          <div class="col-md-7 description">
            <p>
              Réalisation d'un site e-commerce en Nuxtjs 3 migrée nuxtjs 4
              actuellement (Vuejs 3). <br />
              Et réalisation de l'nterface d'administration. <br />
              Base de données MongoDB
              <br />
              <br />
              - page de paiement avec api stripe <br />
              - gestion et envoie de mail avec mailjet <br />
              - ux avec tailwind <br />
              - gestion d'un tracking maison <br />
              - authentification sécurisé <br />
              <br /> <br />
              Url :{" "}
              <a
                href="https://melorianbijoux.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                melorianbijoux.com
              </a>
              <br /> <br />
              ℹ️️ Hébergement Dokeriser sur un VPS Infomaniak
            </p>
          </div>
          <div class="col-md-5 jc-center">
            <div class="row">
              <div class="col-md-12 jc-center">
                <span
                  class="iconify"
                  data-icon="uim:vuejs"
                  style={{ fontSize: "7rem" }}
                ></span>
              </div>
              <div class="col-md-12 jc-center">
                <span
                  class="iconify"
                  data-icon="logos:mongodb"
                  style={{ fontSize: "4.9rem" }}
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MelorianBijoux;
